import { NavbarButton } from '../../types/NavbarButton';
import { NavbarButtonGroup } from '../../types/NavbarButtonGroup';

export function isNavbarButton(
  navItem: NavbarButton | NavbarButtonGroup
): navItem is NavbarButton {
  return (navItem as NavbarButton).path !== undefined;
}
